import { EnumModel } from "api/swagger/ApiClient";
import { ApprovalLevel, Country } from "model/business-keywords";
import { UserContact } from "model/business-types";
import { SystemUserWrapper } from "model/support-types";

export interface CountryChangeRequestModel {
  country: Country;
  requestedBy: UserContact | null;
  effectiveFrom: string | null;
  note: string | null;
  data: CountryChangeRequestData;
  changes: string[];
}

export interface CountryChangeRequestData {
  approvalRequirement: EnumModel;
  approvalLevel: ApprovalLevel;
  approveType: EnumModel;
  approversWrapper: SystemUserWrapper[];
}
